import React from "react";
import MemberDashboard from "@/components/MemberDashboard";

export default function AffiliatorDashboard() {
  return <MemberDashboard role="affiliator" />;
}
